const splitBase64 = (base64data) => {
    let arr = base64data.split(",")

    let mime = arr[0].match(/:(.*?);/)[1]

    return { mime, data: arr[1] }
}

export { splitBase64 }
